export const downloadFileByURL = async (url, title) => {
  const token = localStorage.getItem("jwt_token");

  fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([blob]));
      // console.log(new Blob([blob]));
      // window.open(url)
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title || "contractorPersons.xls");

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
};

export const downloadFileByExistURL = async (url, title) => {
  window.open(url);
  // const link = document.createElement("a");
  // link.href = url;
  // link.setAttribute("download", title || "contractorPersons.xls");

  // // Append to html link element page
  // document.body.appendChild(link);

  // // Start download
  // link.click();

  // setTimeout(() => {
  //   document.body.removeChild(link);
  // }, 1000); // You can adjust the time as needed
};

// Encodes data to Base64 format after URI encoding
export const encodeBase64 = (data) => btoa(encodeURIComponent(data));

// Decodes Base64 encoded data and then performs URI decoding
export const decodeBase64 = (encoded) => decodeURIComponent(atob(encoded));
